import { RouteName } from '@mews-commander/enums';

/**
 * Cache for TemplateFetcher responses, used to enable quick back navigation for several Backend pages.
 */
export const BACKEND_TEMPLATES_CACHE = new Map<string, string>();

/**
 * A whitelist of cache-enabled Backend pages. We should put here only the customer-facing pages,
 * and typically we want the heavily used reports to be cached to support the "batch processing" processes
 * they're being used in.
 */
export const CACHE_ENABLED_BACKEND_PAGES = new Set<RouteName>([
    RouteName.AccountingLedgerReportIndex,
    RouteName.AccountingReportIndex,
    RouteName.PaymentReportIndex,
]);
